class SearchToggle {
  TIMEOUT = 300;
  inputButton;
  searchForm;
  inputWrapper;
  searchSubmit;
  desktopList;
  locationWrapper;
  phoneHeader;
  htmlElement;
  searchInput;

  init() {
    this.inputButton = document.querySelector('.mobile-overlay__search-button');
    this.searchForm = document.querySelector('.mobile-overlay__search-form');
    this.inputWrapper = document.querySelector('.mobile-overlay__search-wrapper');
    this.searchSubmit = document.querySelector('.mobile-overlay__submit-button');
    this.desktopList = document.querySelector('.mobile-overlay__desktop-list');
    this.locationWrapper = document.querySelector('.mobile-overlay__location-wrapper');
    this.phoneHeader = document.querySelector('.mobile-overlay__phone');
    this.htmlElement = document.querySelector('html');
    this.searchInput = document.querySelector('.mobile-overlay__input');

    if (this.inputButton) {
      this.inputButton.addEventListener('click', () => this.toggleSearch());
    }

    const observer = new MutationObserver(() => this.clearSearchInput());
    observer.observe(this.htmlElement, { attributes: true, attributeFilter: ['class'] });
  }

  toggleSearch() {
    const isVisible = this.inputWrapper.classList.toggle('mobile-overlay__search-wrapper--visible');
    this.inputWrapper.classList.toggle('mobile-overlay__search-wrapper--hidden', !isVisible);

    setTimeout(() => {
      this.inputButton.classList.toggle('mobile-overlay__search-button--close', isVisible);
    }, this.TIMEOUT);

    if (isVisible) {
      this.searchForm.classList.add('visible-width');
      this.desktopList.classList.add('desktop-hidden');
      this.locationWrapper.classList.add('desktop-hidden');
      this.phoneHeader.classList.add('desktop-hidden');
    } else {
      setTimeout(() => {
        this.searchInput.value = '';
        this.searchForm.classList.remove('visible-width');
        this.desktopList.classList.remove('desktop-hidden');
        this.locationWrapper.classList.remove('desktop-hidden');
        this.phoneHeader.classList.remove('desktop-hidden');
      }, this.TIMEOUT);
    }
  }

  clearSearchInput() {
    if (this.htmlElement.classList.contains('mobile-hide-navigation')) {
      this.searchInput.value = '';
    }
  }
}

export const searchToggle = new SearchToggle();
